import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { COMPANY_INFO, CORE_SERVICES, MAIN_AREAS } from '../data/siteData';

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="Services - Hærvejens Træpleje"
        description="Fuld oversigt over vores services: Træfældning, topkapning, stubfræsning, beskæring, nabo til banen, hækklipning og alm. skovning."
        canonical="https://xn--hrvejenstrpleje-xlbj.dk/services/"
      />

      <Breadcrumbs items={[{ label: 'Services' }]} />

      {/* Header */}
      <section className="bg-[#122b1f] text-white py-14 sm:py-20 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto text-center">
          <span className="text-xs font-bold text-[#7dd2a6] bg-[#1a3d2c] px-3.5 py-1.5 rounded-full inline-block mb-4">
            Vores ydelser
          </span>
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight mb-4">
            Services & Træpleje
          </h1>
          <p className="text-base sm:text-lg text-[#cadcd1] max-w-2xl mx-auto leading-relaxed">
            Hos Hærvejens Træpleje leverer vi et bredt spektrum af specialiserede ydelser for private, virksomheder og forsyningsselskaber i hele Østjylland og Trekantområdet.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {CORE_SERVICES.map((service, index) => (
            <article
              key={service.slug}
              className="bg-white rounded-2xl overflow-hidden border border-[#dce5df] shadow-xs hover:border-[#357959] transition-all flex flex-col group"
            >
              <div className="relative aspect-16/10 overflow-hidden bg-[#e6ede7]">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-104 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 w-10 h-10 rounded-xl bg-white/95 text-[#1b4332] flex items-center justify-center text-sm shadow-xs">
                  <i className={`fa-solid ${service.icon}`} aria-hidden="true" />
                </div>
              </div>

              <div className="p-6 sm:p-7 flex-1 flex flex-col">
                <span className="text-xs font-semibold text-[#527a65] mb-1">
                  Ydelse #{index + 1}
                </span>
                <h2 className="text-2xl font-bold text-[#14291d] mb-3 group-hover:text-[#2d6a4f] transition-colors">
                  <Link to={`/${service.slug}`}>{service.title}</Link>
                </h2>
                <p className="text-sm text-[#485b50] leading-relaxed mb-6 flex-1">
                  {service.intro}
                </p>

                <div className="pt-4 border-t border-[#edf2ee] flex items-center justify-between">
                  <Link
                    to={`/${service.slug}`}
                    className="inline-flex items-center gap-1.5 text-sm font-bold text-[#1b4332] hover:text-[#2d6a4f]"
                  >
                    <span>Læs mere om {service.shortTitle}</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Cross link to Areas Hub */}
      <section className="py-12 bg-[#f2f7f4] border-y border-[#dce8e0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-[#14291d] mb-2">
            Har du brug for hjælp i et specifikt lokalområde?
          </h3>
          <p className="text-sm text-[#475a4f] max-w-xl mx-auto mb-6">
            Vi kører dagligt ud til opgaver i hele Trekantområdet og Østjylland. Se vores lokale bysider og faste tilbud.
          </p>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {MAIN_AREAS.map((a) => (
              <Link
                key={a.slug}
                to={`/${a.slug}`}
                className="px-4 py-2 rounded-xl bg-white border border-[#cfddd4] text-sm font-semibold text-[#1c2c22] hover:bg-[#1b4332] hover:text-white hover:border-[#1b4332] transition-colors shadow-2xs"
              >
                Træpleje i {a.name}
              </Link>
            ))}
            <Link
              to="/omraader"
              className="px-4 py-2 rounded-xl bg-[#2d6a4f] text-white text-sm font-semibold hover:bg-[#204e39] transition-colors"
            >
              Se samlet Områdehub »
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
